"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminUserRole = void 0;
var AdminUserRole;
(function (AdminUserRole) {
    /** Can only view data */
    AdminUserRole[AdminUserRole["Viewer"] = 0] = "Viewer";
    /** Can view and edit data */
    AdminUserRole[AdminUserRole["Editor"] = 1] = "Editor";
    /** Has full permissions */
    AdminUserRole[AdminUserRole["SuperAdmin"] = 2] = "SuperAdmin";
})(AdminUserRole = exports.AdminUserRole || (exports.AdminUserRole = {}));
